import z from "zod";
import { InventoryCostPool } from "./enums/InventoryCostPool";

export const InventoryCostingSettingsScheme = z.object({
  pool: z.enum(InventoryCostPool),
  activatedAt: z.iso.datetime(),
});

export const RestActivateInventoryCosting = InventoryCostingSettingsScheme.pick(
  { pool: true },
);

export type RestActivateInventoryCosting = z.infer<
  typeof RestActivateInventoryCosting
>;
export type InventoryCostingSettings = z.infer<
  typeof InventoryCostingSettingsScheme
>;
